import {
  studentLevelCodes,
  frequencyCodes,
  genderCodes,
  availableTimeCodes,
  physicalEvaluationCodes,
  objectiveCodes,
} from './constants';

type Props = {
  studentLevel: string;
  frequency: string;
  gender: string;
  availableTime: string;
  physicalEvaluation: string;
  objective: string;
};

export function getProfileCode({
  studentLevel,
  frequency,
  gender,
  availableTime,
  physicalEvaluation,
  objective,
}: Props) {
  const a = studentLevelCodes.filter((item) => item.value === studentLevel)[0];
  const b = frequencyCodes.filter((item) => item.value === frequency)[0];
  const c = genderCodes.filter((item) => item.value === gender)[0];
  const d = availableTimeCodes.filter(
    (item) => item.value === availableTime,
  )[0];
  const e = physicalEvaluationCodes.filter(
    (item) => item.value === physicalEvaluation,
  )[0];
  const f = objectiveCodes.filter((item) => item.value === objective)[0];

  const profileCode = `${c?.label || ''}${a?.label || ''}${e?.label || ''}${
    f?.label || ''
  }${b?.label || ''}${d?.label || ''}`;

  return profileCode;
}
